// Staging.
export const environment = {
    production: false,
    apiPath: 'https://schooladminportal.com/spectrum-api',
    externalApiPath: 'https://schooladminportal.com/spectrum-api',
    authBaseUrl: 'https://schooladminportal.com'
};
